import Navigation from "./modules/Navigation";
import {wbsAnimations, wbsSequence} from "./modules/wbsAnimations";
import wbsFilters from "./modules/wbsFilters";
import {Carousels} from "./modules/Carousels";
import BookingCalendar from "./modules/BookingCalendar";




new Navigation();

wbsAnimations();
wbsSequence();
wbsFilters();

const wbsCalendarRoomItemToggle = () => {

    $(document).on('click', '.room-item__calendar-toggle', function () {
        const $this = $(this);
        const svg = $this.find('svg');
        svg.toggleClass('rotate-180');

        $this.parents('.room-item').find('.room-item__calendar').slideToggle();
    });
}

wbsCalendarRoomItemToggle();

Carousels('.small-carousel', {
    perPage: 1,
    autoplay: true,
    type: 'loop',
});


new BookingCalendar();